import { stringSchema, objectSchema, booleanSchema } from '@/schemas'

export const proposalSectionSchema = objectSchema({
  type: stringSchema.min(1, 'Type is required'),
  template_id: stringSchema.min(1, 'Template is required'),
  is_enabled: booleanSchema.optional(),
  include_in_pdf: booleanSchema.optional(),
})
